import Swal from "sweetalert2";
import BaseUrl from "./component/BaseUrl";

const AxiosInterceptorsSetup = navigate => {
    // debugger
    BaseUrl.interceptors.response.use(
        response => response,
        error => {
            if (error.response.status === 401) {
                Swal.fire({
                    title: "User Session has been Expired!",
                    timer: 2000,
                    icon: 'error',
                    showConfirmButton: false,
                })
                setTimeout(() => {
                    localStorage.removeItem('pacificadmin');
                    navigate('/');
                }, 2000);
            }
            return Promise.reject(error);
        }
    );
};

export default AxiosInterceptorsSetup;